import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';

import ImgForecastPuck from '@/shared/pictures/forecast_puck.png';
import ImgForecastHockey from '@/shared/pictures/forecast_hockey.png';
import { useStore } from '@/app/providers/StoreProvider';
import { IBet } from '../types';
import { NumberWheel } from './NumberWheel';


interface PropsResultMatch {
  isActual:boolean
  isAcceptingBets:boolean
  isBet:IBet | undefined

}
export const ResultMatch:FC<PropsResultMatch> = observer(({ isActual, isAcceptingBets, isBet}) => {
  const { forecastStore } = useStore();

  if(!isActual) return null;
  return (
    <div className="forecast-result">

        <h2 className="forecast-result_title">Результат действий Овечкина<br/>
        <span>с учетом овертайма, но без послематчевого буллита:</span></h2>

        <div className='forecast-result_actions'>

            <div className='forecast-result_action'>
                <img className='forecast-result_action__icon' src={ImgForecastPuck} alt="icon" />
                <p className='forecast-result_action__text'>Шайбы</p>
                <NumberWheel inputClass='forecast-result_action__score' value={isBet?isBet.oviGoals:forecastStore.bet.oviGoals} disabled={!!isBet || !isAcceptingBets} onChange={(value) => forecastStore.setOviGoals(value)} />
            </div>

            <div className='forecast-result_action'>
                <img className='forecast-result_action__icon' src={ImgForecastHockey} alt="icon" />
                <p className='forecast-result_action__text'>Передачи</p>
                <NumberWheel inputClass='forecast-result_action__score' value={isBet?isBet.oviHelps:forecastStore.bet.oviHelps} disabled={!!isBet || !isAcceptingBets} onChange={(value) => forecastStore.setAOviHelps(value)} />
            </div>

        </div>

    </div>
  );


});
